<template>
	<v-card>
   <v-toolbar color="blue-grey white--text">
      <!-- <v-btn icon class="hidden-xs-only" @click="back()">
        <v-icon>arrow_back</v-icon>
      </v-btn> -->
      <v-toolbar-title class="white--text">รายงานค่าตอบแทน</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text"></v-toolbar-title>
    </v-toolbar> 

    <v-card-text>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 md3 d-flex>
            <v-menu
              ref="menuFromDate"
              :close-on-content-click="false"
              v-model="menuFromDate"
              :nudge-right="40"
              :return-value.sync="params.fromDate"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                :value="date(params.fromDate)"
                label="ตั้งแต่วันที่"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="params.fromDate" @input="$refs.menuFromDate.save(params.fromDate)" no-title locale="th-Th"></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs12 md3 d-flex>
            <v-menu
              ref="menuToDate"
              :close-on-content-click="false"
              v-model="menuToDate"
              :nudge-right="40"
              :return-value.sync="params.toDate"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                :value="date(params.toDate)"
                label="ถึงวันที่"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="params.toDate" @input="$refs.menuToDate.save(params.toDate)" no-title locale="th-Th"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>

        <div>
          <v-radio-group v-model="guest" :mandatory="false" :disabled="!active">
            <v-radio color="blue" value="true" label="วิทยากร"></v-radio>
          </v-radio-group>
        </div>

        <div>
          <v-radio-group v-model="guest" :mandatory="false" :disabled="!active">
            <v-radio color="blue" value="false" label="บุคลากร"></v-radio>
          </v-radio-group>
        
          <v-layout class="ml-3" v-if="guest === 'false'">
            <v-flex xs12 md12>

              <v-list
                subheader
                two-line
              >
                <v-subheader>เลือกประเภทรายงาน</v-subheader>

                <v-list-tile @click="">
                  <v-list-tile-action>
                    <v-radio-group v-model="params.type" :mandatory="false" :disabled="!active">
                      <v-radio color="deep-orange" value="type-1"></v-radio>
                    </v-radio-group>
                  </v-list-tile-action>

                  <v-list-tile-content @click="() => { if(active) params.type = 'type-1'}">
                    <v-list-tile-title>แสดงแบบประเภทบุคลากร</v-list-tile-title>
                    <v-list-tile-sub-title> </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile @click="" class="blue-grey lighten-5">
                  <v-list-tile-action>
                    <v-radio-group v-model="params.type" :mandatory="false" :disabled="!active">
                      <v-radio color="deep-orange" value="type-2"></v-radio>
                    </v-radio-group>
                  </v-list-tile-action>

                  <v-list-tile-content @click="() => { if(active) params.type = 'type-2'}">
                    <v-list-tile-title>แสดงแบบรายคณะ</v-list-tile-title>
                    <v-list-tile-sub-title>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                
                <!-- <v-slide-y-transition mode="out-in"> -->
                <v-list-tile class="blue-grey lighten-5" v-if="params.type === 'type-2'">
                  <v-list-tile-action></v-list-tile-action>
                  <v-list-tile-content>
                    <v-spacer></v-spacer>
                    <v-list-tile-sub-title>
                      <v-select
                        :items="facultyItems"
                        v-model="params.faculty" 
                        label="คณะ"
                        item-text="nameTh" 
                        item-value="id"
                        required
                        solo
                        dark
                        return-object
                        persistent-hint
                        :disabled="params.type != 'type-2'"
                        @input="initDepartmentItems()"
                      ></v-select>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>

                </v-list-tile>
                <v-list-tile class="blue-grey lighten-5 pb-2" v-if="params.type === 'type-2'">
                  <v-list-tile-action></v-list-tile-action>
                  <v-list-tile-content>
                    <v-spacer></v-spacer>
                    <v-list-tile-sub-title>
                     <v-select
                        :items="departmentItems"
                        v-model="params.department"
                        label="สาขา"
                        item-text="name"
                        item-value="id"
                        required
                        solo
                        dark
                        persistent-hint
                        :disabled="params.type != 'type-2'"
                      ></v-select>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>

                </v-list-tile>
                <!-- </v-slide-y-transition> -->

                <v-list-tile @click="">
                  <v-list-tile-action>
                    <v-radio-group v-model="params.type" :mandatory="false" :disabled="!active">
                      <v-radio color="deep-orange" value="type-3"></v-radio>
                    </v-radio-group>
                  </v-list-tile-action>

                  <v-list-tile-content @click="() => { if(active) params.type = 'type-3'}">
                    <v-list-tile-title>แสดงแบบผลรวมของทุกคณะ</v-list-tile-title>
                    <v-list-tile-sub-title> </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile class="blue-grey lighten-5 pb-2">
                  <v-list-tile-action>
                    <v-radio-group v-model="params.type" :mandatory="false" :disabled="!active">
                      <v-radio color="deep-orange" value="type-4"></v-radio>
                    </v-radio-group>
                  </v-list-tile-action>

                  <v-list-tile-content @click="() => { if(active) params.type = 'type-4'}">
                    <v-list-tile-title>แสดงแบบรายบุคคล</v-list-tile-title>
                    <v-list-tile-sub-title> </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile class="blue-grey lighten-5" v-if="params.type === 'type-4'">
                  <v-list-tile-action></v-list-tile-action>
                  <v-list-tile-content>
                    <v-spacer></v-spacer>
                    <v-list-tile-sub-title>
                      <v-radio-group v-model="params.insider" row>
                        <v-radio label="บุคคลภายใน" value="true"></v-radio>
                        <v-radio label="บุคคลภายนอก" value="false"></v-radio>
                      </v-radio-group>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

              </v-list>

            </v-flex>
          </v-layout>

        </div>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-slide-x-transition mode="out-in">
        <v-btn
          color="info"
          target="_new" 
          :href="printoutUrl"
          v-if="active"
        >
          <v-icon left dark>cloud_download</v-icon> ส่งออกข้อมูล
        </v-btn>
      </v-slide-x-transition>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config/index'
import swal from 'sweetalert2'
import moment from 'moment'

export default {
	data () {
		return {
      type: 'type-1',
      active: false,
      menuFromDate: false,
      menuToDate: false,
      disabled: true,
      loading: false,
      params: {
        fromDate: null,
        toDate: null,
        type: 'type-1',
        faculty: null,
        department: '',
        insider: false
      },
      guest: 'true',
      // facultyItems: [],
      departmentItems: []
		}
	},
	mounted () {},
  computed: {
    ...mapGetters ({
      facultyItems: 'university/facultyItems',
      token: 'token'
    }),
    printoutUrl () {
      if(this.guest === 'false') {
        console.log('printout',this.guest)
        return `${config.serverURI}/wages/printout?fromDate=${this.params.fromDate}&toDate=${this.params.toDate}&type=${this.params.type}&faculty=${this.facultyId}&department=${this.params.department}&insider=${this.params.insider}&access_token=${this.token}`
      }
      if(this.guest === 'true') {
        return `${config.serverURI}/instructors/wage/printout?fromDate=${this.params.fromDate}&toDate=${this.params.toDate}&access_token=${this.token}`
      }
    },
    facultyId () {
      return this.params.faculty ? this.params.faculty.id : this.params.faculty
    }
  },
  mounted () {
    this.$store.dispatch('university/fetchFaculties')
  },
  methods: {
    date (val) {
      return val ? this.$options.filters.formatFullDate(val) : null
    },
    initDepartmentItems () {
      this.departmentItems = this.params.faculty.departments
      this.departmentItems.unshift({name: 'ทั้งหมด', id: ''})
    }
  },
  watch: {
    'params': {
      handler (val) {
       // console.log('watch fromDate', val.fromDate)
       // console.log('watch toDate', val.toDate)
       if( val.fromDate && val.toDate ) {
          let fd = moment(val.fromDate)
          let td = moment(val.toDate)
          if(td.diff(fd) < 0) this.params.fromDate = this.params.toDate
          this.active = true
        }
        // if( val.type === 'type-2' && this.facultyItems.length == 0 ) this.loadFacultyItems()

        if(val.faculty) this.departmentItems = val.faculty.departments
        // console.log('watch->personData->department', val.department )
      },
      deep: true
    }
    
  }
}
</script>

<style scoped>
  .boxes {
    min-width: 400px;
  }
</style>


// WEBPACK FOOTER //
// src/components/reports/wage/index.vue